module.exports = __webpack_public_path__ + "img/2.1-Procedimento-preventivo-2.0.ce472027.svg";